import { fetch } from '@/shared/fetch';

export const editNewbornDueDate = async (dueDate: Date): Promise<void> => {
    await fetch<void>('/api/newborn/due-date', 'PATCH', dueDate);
};
